import React, { Component } from 'react';
import { Icon, Container, Grid, Header, List, Segment, Button } from 'semantic-ui-react';

class Footer extends Component {
  render() {
    return (
      <Segment vertical style={{ paddingTop: '5em', backgroundColor:'#FFB805' }}>
        <Container>
          <Grid divided stackable>
            <Grid.Row>
              <Grid.Column width={2}>
                <Header as='h4' content='Navigate.' />
                <List link>
                  <List.Item as='a' href='/home'>Home</List.Item>
                  <List.Item as='a' href='/home#request-acesss'>Request Access</List.Item>
                  <List.Item as='a' href='/about'>About</List.Item>
                  <List.Item as='a' href='https://medium.com/beemabroker'>Blog</List.Item>
                  <List.Item as='a' href='/faq'>FAQ</List.Item>
                  <List.Item as='a' href='/licenses'>Licenses</List.Item>
                  <List.Item as='a' href='/privacy'>Privacy</List.Item>
                  <List.Item as='a' href='/terms'>Terms</List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={4}>
                <Header as='h4' content='Contact.' />
                <List>
                  <List.Item> <b> hello@beemabroker.com </b></List.Item>
                  <List.Item> <b> 1-510-629-1377 </b></List.Item>
                </List>
                <List link horizontal>
                  <List.Item as='a' href='https://medium.com/beemabroker'><Icon name='medium' color='black' size='large'/></List.Item>
                  <List.Item as='a' href='https://www.instagram.com/beemabroker/'><Icon name='instagram' color='black' size='large'/></List.Item>
                  <List.Item as='a' href='https://www.linkedin.com/company/beemabroker/'><Icon name='linkedin square' color='black' size='large'/></List.Item>
                  <List.Item as='a' href='https://twitter.com/beemabroker?lang=en'><Icon name='twitter square' color='black' size='large'/></List.Item>
                  <List.Item as='a' href='https://www.youtube.com/channel/UCUIO2qZ7aTtKOZ3wX1FbIZw'><Icon name='youtube square' color='black' size='large'/></List.Item>
                  <List.Item as='a' href='https://www.facebook.com/BeemaBroker/'><Icon name='facebook' color='black' size='large'/></List.Item>
                </List>

              </Grid.Column>
              <Grid.Column width={3}>
                <Header as='h4'>Our Products.</Header>
                  <List link>
                    <List.Item as='a'>Directors & Officers</List.Item>
                    <List.Item as='a'>Tech Errors & Omissions</List.Item>
                    <List.Item as='a'>Workers Compensation</List.Item>
                    <List.Item as='a'>Cyber</List.Item>
                    <List.Item as='a'>Product Liability</List.Item>
                    <List.Item as='a'>Professional Liability</List.Item>
                    <List.Item as='a'>Property</List.Item>
                    <List.Item as='a'>General Liability</List.Item>
                    <List.Item as='a'>Business Owner Policy</List.Item>
                    <List.Item as='a'>Business Auto</List.Item>
                    <List.Item as='a'>Umbrella</List.Item>
                  </List>
              </Grid.Column>
              <Grid.Column width={3}>
                <Header as='h4'>Our Specialities.</Header>
                  <List link>
                    <List.Item as='a'>Startups</List.Item>
                    <List.Item as='a'>Small Business Owners</List.Item>
                    <List.Item as='a'>Freelancers</List.Item>
                    <List.Item as='a'>Solopreneurs</List.Item>
                    <List.Item as='a'>Nonprofits</List.Item>
                    <List.Item>
                      <a href='/home#request-acesss'>
                        <Button color='black' compact>
                           Join Private Beta
                        </Button>
                      </a>
                  </List.Item>
                  </List>
              </Grid.Column>
              <Grid.Column width={4}>
                <Header as='h4'>Our Mission.</Header>
                  <p>
                    <b>
                    BeemaBroker makes the learning, purchasing, and managing
                    of business insurance easy and transparent for millennial
                    entrepreneurs and small business owners.
                    </b>
                  </p>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <b> © 2018 BeemaBroker Insurance Services, LLC </b>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
};

export default Footer;



// WEBPACK FOOTER //
// ./src/js/Footer.js